export const LOAD_QVCT_POPULATION = 'LOAD_QVCT_POPULATION'